export enum VshCoreEntityKeys {
  User = 'user',
  ClientUser = 'client-user',
  Client = 'client'
}
